




























































































import downloadApp from "./common/downloadApp.vue"
import groupBox from "./group/groupBox.vue"
import channelDetailIntro from "./channel/channelDetailIntro.vue"
import coupon from "./comps/coupon.vue"
import channelClass from "./channel/channelClass.vue"
import showBindPhone from "@ivy/fts/showBindPhone"
import * as util from "../util"
import * as weixin from '@ivy/fts/weixin'
import RichText from '@ivy/fts/comps/RichText.vue'
import { Component, Vue } from "vue-property-decorator"
import openApp from '@ivy/fts/openApp'
import config from '../config'
import { isXcxWeb } from '@ivy/fts/utils'

@Component({
  components: {
    groupBox,
    channelDetailIntro,
    coupon,
    channelClass,
    downloadApp,
    RichText
  }
})
export default class Index extends Vue {
  isXcxWeb = isXcxWeb()
  selected = "detail"
  detail: any = {
    activity: {
      id: undefined,
      activity_type: undefined,
      limit_count: 0,
      used_count: 0
    }
  }
  hasBought = false // 是否已购
  isAdminCheck = "" // 是否是超级管理员进入
  couponVisible = false // 是否展示优惠券列表
  hasCoupon = false // 课程是否有优惠券
  couponList = [] // 优惠券列表
  group = {}
  groupJoined = false
  get noscroll() {
    return this.couponVisible || (this.detail.has_bought && !this.detail.can_learn)
  }
  get isLimitBuy() {
    let activity = this.detail.activity
    return activity.id && activity.activity_type === 'limit_buy' && (+activity.limit_count > +activity.used_count || !+activity.limit_count)
  }
  get isGroupBuy() {
    let activity = this.detail.activity
    return activity.id && activity.activity_type === 'group'
  }
  get isLimitFree() {
    let activity = this.detail.activity
    return activity.id && activity.activity_type === 'limit_free'
  }
  get showPb() {
    return !(this.hasBought || this.isLimitFree)
  }
  async mounted() {
    // 这个地方是为了后台管理员上新查看未发布课程时，可以预览效果
    let isAdminCheck = await this.$store.login()
    this.isAdminCheck = isAdminCheck === "adminCheck" ? "adminCheck" : ""
    let { id, result, try_listen } = this.$route.query
    // 不知道为什么最近会有一堆id后面接着乱七八糟字符串的链接，防止报错，先把这个加上
    if (try_listen) this.selected = 'list'
    let idResult = /^(\d+)/.exec(`${id}`)
    if (!idResult) return this.$MessageBox('地址有误，请退出重试~')
    id = idResult[0]
    await this.getDetail(id)
    this.$title(this.detail.title)
    if (result === "chooseWXPay:ok") {
      this.$Toast(`支付成功`)
    }
    this.getCouponList(id)
  }
  updateGroup(group) {
    this.groupJoined = group && group.joined
  }
  async getDetail(id) {
    let { data } = await this.$axios.get("/api/mobile/knowlege/course/getCourseDetail", { params: { id, isAdminCheck: this.isAdminCheck } })
    this.$Indicator.close()
    if (!data.detail) {
      this.$Toast(`未找到该课程信息`)
      return
    }
    this.detail = {
      ...data.detail,
      pic_url: util.transAliImgResize(data.detail.pic_url, 750, 450),
      sale_price: data.detail.activity.sale_price && (+data.detail.activity.sale_price).toFixed(1)
    }
    this.hasBought = data.detail.has_bought
    data.detail.has_bought && data.detail.can_learn && (this.selected = 'list')
    await this.setShare(this.detail.shareData)
  }
  async getCouponList(id) {
    id = id || this.detail.id
    let { data } = await this.$axios.get(`/api/mobile/knowlege/marketing/getCouponList`, {
      params: { courseId: id }
    })
    this.couponList = data
    if (data.length) this.hasCoupon = true
  }
  async toTryDetail() {
    if (this.selected === 'detail') this.selected = 'list'
    await this.$nextTick()
    let channelClassRef: any = this.$refs.channelClass
    channelClassRef.toTryListenPage()
  }
  toPlayPage(item) {
    if (!this.hasBought && !item.is_try && !this.isLimitFree) {
      return this.$Toast({
        message: `购买才能观看哦~`,
        iconClass: "error-tip"
      })
    }
    this.$router.push({
      path: "lessonPlayPage",
      query: {
        lessonId: item.id,
        spuId: this.$route.query.spuId
      }
    })
  }
  async toPay(payType = 'normal') {
    if (!this.$store.logined.token) {
      // 用户尚未注册
      let logined = await this.bindPhone()
      if (logined && logined.token) {
        this.$router.go(0)
      }
      return
    }
    if (this.detail.id) {
      let activityObj = payType === 'limit' ? { limit_buy: { activityId: this.detail.activity.id } } : payType === 'group' ? { group: { organizerId: 0 } } : {}
      util.pay(this.detail.id, { exclusive_activity: activityObj })
    }
  }
  async showCoupon() {
    if (!this.$store.logined.token) {
      // 用户尚未注册
      let logined = await this.bindPhone()
      if (!logined || !logined.token) return
    }
    await this.getCouponList(this.detail.id)
    this.couponVisible = true
  }
  async bindPhone() {
    if (this.detail.activity.id) {
      this.Cookies.set(`_cookieRegister`, `${this.detail.activity.activity_type}${this.detail.activity.id}`, { domain: config.env === 'production' ? 'ivydad.com' : 'ivydad.com.cn' })
    }
    return await showBindPhone(this.$store.bindPhoneConfig)
  }
  hideCoupon() {
    this.couponVisible = false
  }
  async setShare(opt) {
    await weixin.wxConfigReady()
    let options = {
      title: opt.title,
      desc: opt.content,
      imgUrl: opt.pic_url,
      link: opt.url,
    }
    await weixin.weixinShare(options)
  }
  toActivityHomePage(activity) {
    if (!activity.url) return
    window.location.href = activity.url
  }
  goApp() {
    openApp()
  }
}
